var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceSensorLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 13.8,
    y1: 17.9,
    x2: 18.3,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "17.9,34 21.9,34  30,34 38.1,34 42.1,34  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 30,
    y1: 50.2,
    x2: 30,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 46.2,
    y1: 17.9,
    x2: 38.1,
    y2: 34
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M46.2,42.1 c2.5-3.4,4-7.6,4-12.1c0-4.5-1.5-8.7-4-12.1c-1.2-1.5-2.5-2.9-4.1-4.1c-3.4-2.5-7.6-4-12.1-4c-4.5,0-8.7,1.5-12.1,4 c-1.5,1.2-2.9,2.5-4.1,4.1c-2.5,3.4-4,7.6-4,12.1c0,4.5,1.5,8.7,4,12.1c1.2,1.5,2.5,2.9,4.1,4.1c3.4,2.5,7.6,4,12.1,4 c4.5,0,8.7-1.5,12.1-4C43.6,45,45,43.6,46.2,42.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 17.4,24.8 17.4,24.8 21.1,23 21.1,32.1 13.8,26.7 17.4,24.8  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceSensorLight);
export default __webpack_public_path__ + "static/media/device-sensor-light.68141e1d8145b512b81c5fc4f6940d36.svg";
export { ForwardRef as ReactComponent };